module.exports = __webpack_public_path__ + "img/maestro.e79a5de3.png";